import { render, staticRenderFns } from "./PesquisaView.vue?vue&type=template&id=1d7bb129&scoped=true"
import script from "./PesquisaView.vue?vue&type=script&lang=js"
export * from "./PesquisaView.vue?vue&type=script&lang=js"
import style0 from "./PesquisaView.vue?vue&type=style&index=0&id=1d7bb129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bb129",
  null
  
)

export default component.exports